import { useEffect } from 'react';
import {useLocation, useSearchParams} from 'react-router-dom';
import { observer } from "mobx-react";
import pageUrlCoordinatorStore from "./page-url-coordination-store";

/**
 * The Dashboard application runs in an iframe. That is why the Dashboard application needs to communicate SPA route changes to the
 * parent Laravel application to make it change the URL in the browser.
 * The opposite communication (parent -> Dashboard app) is needed when a user click the "Back" browser button to open
 * the previous page in the history. In this situation, the Dashboard application must change its SPA route to reconcile
 * it with the browser URL.
 */
const PageUrlCoordinator = observer(() => {
    const location = useLocation();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        pageUrlCoordinatorStore.changeParentPath(location.pathname, searchParams);
    }, [location, searchParams]);

    useEffect(() => {
        const backBtnClickHandler = () => {
            window.history.back();
        };

        const unsubscribe = pageUrlCoordinatorStore.subscribeToBrowserHistoryBackNavigation(backBtnClickHandler);

        return () => {
            unsubscribe();
        };
    }, []);

    return null;
});

export default PageUrlCoordinator;